import L from 'leaflet';
import 'leaflet-easyprint';
import { useEffect } from 'react';
import { useMap } from 'react-leaflet';


function MapPrint(props) {
  const map = useMap();
  useEffect(() => {
    const control = L.easyPrint({
      ...props
    });
    map.addControl(control)
    var outlines = L.layerGroup();

    L.polyline(
      [
        [9.671467871363895, 45.695974416054561, ],
        [9.671533498396553, 45.695928958228521, ],
        [9.671605915435855, 45.695878794795291, ],
        [9.671621731623876, 45.695868252741136,],
        [9.671630669906362, 45.695864490048166, ],
        [9.671643508831504, 45.6958586738332, ],
        [9.671652273061511, 45.695856251486745, ],
        [9.671675558374751, 45.695851945399184, ],
        [9.671684286362588, 45.695851645661364, ],
        [9.671710474451446, 45.695851734711859,],
        [9.671720774666843, 45.695854445508914, ],
        [9.6717289324143, 45.695856080700743, ],
        [9.671746684470818, 45.695861972681172, ],
        [9.671762392419787, 45.695868996382757, ],
        [9.672130217192917, 45.69606038792061, ],
        [9.6721560334767, 45.696073819200599, ],
        [9.672317971803162, 45.696158079970523, ],
        [9.672435833258028, 45.696220014146078, ],
        [9.672724869149846, 45.696370772347258, ],
        [9.673098349391809, 45.696565578372308, ],
        [9.673270493417965, 45.696655335673618, ],
        [9.673639703606655, 45.696847749259476, ],
        [9.673845817052037, 45.696955166648408, ],
        [9.673909131325862, 45.696988696642855, ],
        [9.624085592703893, 45.657101991436334],
      ],{offset: 10, width: 20,color: '#FF0000',}).addTo(outlines)

    map.addLayer(outlines)
    return () => {
      map.removeControl(control);
    }
  }, [map,props]);


  return null;
}

export default MapPrint